import React, { useState } from "react"
import PropTypes from "prop-types"
import Markdown from "markdown-to-jsx"
import Container from "components/Container"
import Modal from "components/Modal"
import InvisibleButton from "components/buttons/InvisibleButton"
import theme from "styles/theme"

import { ReactComponent as Arrow } from "images/icons/arrow.svg"

const SurveyBlock = ({ title, copy, inlineSurvey, popupSurvey, bgColor }) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      {modalOpen && (
        <Modal
          onRequestClose={() => {
            setModalOpen(false)
          }}
          css={{
            width: "100%",
            maxWidth: 550,
            margin: "0 30px",
          }}
        >
          <iframe
            title={`Survey: ${title}`}
            src={popupSurvey.url}
            width="100%"
            height="476"
            css={{
              border: 0,
              boxShadow: theme.cardShadow,
              [theme.mobile]: {
                height: 450,
                minHeight: 200,
                maxHeight: "calc(100vh - 80px)",
              },
            }}
          />
        </Modal>
      )}
      <Container
        id="survey-block"
        max={1140}
        wrapperStyles={theme.expandQueries({
          // background: theme.nearWhite,
          backgroundColor: theme?.[bgColor] ?? theme.nearWhite,
          padding: ["100px 0", "70px 10px", "45px 10px 65px"],
        })}
        css={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 38,
          margin: "0 auto",
          [theme.tablet]: {
            gridTemplateColumns: "1fr",
            maxWidth: 495,
            textAlign: "center",
          },
        }}
      >
        <div
          css={{
            ...theme.bodyCopy,
            maxWidth: 452,
            [theme.tablet]: {
              maxWidth: 369 + 60,
              padding: "0 30px",
              marginLeft: "auto",
              marginRight: "auto",
            },
          }}
        >
          <h2 css={{ ...theme.t3, marginBottom: 30 }}>{title}</h2>
          <Markdown options={{ forceBlock: true }}>{copy}</Markdown>
          {popupSurvey && (
            <div css={{ marginTop: 30 }}>
              <InvisibleButton
                onClick={() => {
                  setModalOpen(true)
                }}
                css={{
                  ...theme.t5sm,
                  color: theme.gray,
                  textDecoration: "none",
                  textTransform: "uppercase",
                  paddingBottom: 5,
                  borderBottom: "2px solid currentColor",
                  display: "inline-flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "color 250ms",
                  ":hover": {
                    color: theme.midBlue,
                  },
                }}
              >
                Complete Survey
                <Arrow
                  css={{ marginLeft: 8, path: { strokeWidth: 1.8 } }}
                  width="20"
                />
              </InvisibleButton>
            </div>
          )}
        </div>
        <iframe
          title={`Survey: ${title}`}
          src={inlineSurvey.url}
          width="100%"
          height="476"
          css={{
            border: 0,
            boxShadow: theme.cardShadow,
            [theme.mobile]: {
              height: 450,
              minHeight: 200,
              maxHeight: "calc(100vh - 80px)",
            },
          }}
        />
      </Container>
    </>
  )
}

export default SurveyBlock

SurveyBlock.propTypes = {
  title: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  inlineSurvey: PropTypes.shape({ url: PropTypes.string.isRequired })
    .isRequired,
  popupSurvey: PropTypes.shape({ url: PropTypes.string.isRequired }),
}
